export default "__VITE_ASSET__d13b7285__"